import React from 'react';
import { Form, Label, Input } from 'reactstrap';
import propTypes from 'prop-types';

import { perPageOptions, customerReviewSortOptions } from '../../../../constants/kickavenue';
import { SortRow } from '../../styled';

const SortForm = props => (
  <Form onSubmit={e => e.preventDefault()}>
    <SortRow>
      <Label for="customer_review_per_page">Show</Label>
      <Input
        type="select"
        name="per_page"
        id="customer_review_per_page"
        onChange={props.onInputChange}
        value={props.per_page}
        disabled={props.isLoading}
      >
        { perPageOptions.map(option => (
          <option value={option.value} key={option.value}>{option.label}</option>
        )) }
      </Input>
      <Label for="customer_review_sort">Sort By</Label>
      <Input
        type="select"
        name="sort"
        id="customer_review_sort"
        onChange={props.onInputChange}
        value={props.sort}
        disabled={props.isLoading}
      >
        { customerReviewSortOptions.map(option => (
          <option value={option.value} key={option.value}>{option.label}</option>
        )) }
      </Input>
    </SortRow>
  </Form>
)

export default SortForm;

SortForm.propTypes = {
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort: propTypes.string,
  isLoading: propTypes.bool,
  onInputChange: propTypes.func.isRequired
}

SortForm.defaultProps = {
  per_page: 15,
  sort: 'created_at_desc',
  isLoading: false
}
